import { createAction } from "redux-actions";

export const changeBlocksShadowsToOnAction = createAction(
  "CHANGE_BLOCKS_SHADOWS_ON"
);
export const changeBlocksShadowsToOffAction = createAction(
  "CHANGE_BLOCKS_SHADOWS_OFF"
);
